import { render, staticRenderFns } from "./NewPublicationForm.vue?vue&type=template&id=6de0ae03"
import script from "./NewPublicationForm.vue?vue&type=script&lang=js"
export * from "./NewPublicationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports